export default [
  {
    path: '/login',
    name: 'Login',
    view: 'Login',
    meta: {
      plainLayout: true,
      requiresAuth: false
    }
  },
  {
    path: '/dashboard',
    view: 'Dashboard',
    name: 'Dashboard',
    meta: {
      plainLayout: false,
      requiresAuth: true
    }
  },
  {
    path: '/daily-quiz',
    name: 'Daily Quiz',
    view: 'DailyQuiz',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/latex-test',
    name: 'Latex Test',
    view: 'LatexTest',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/special-model-test',
    name: 'Special Model Test',
    view: 'SpecialModelTest',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/crash-course-payment',
    name: 'Crash Course Payment',
    view: 'CrashCoursePayment',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/all-payments',
    name: 'All Payments',
    view: 'UserAllPayment',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/crash-course',
    name: 'Crash Course ',
    view: 'CrashCourses',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/crash-course-subject',
    name: 'Crash Course Subject',
    view: 'CrashCourseSubjects',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/crash-course-material',
    name: 'Crash Course Material',
    view: 'CrashCourseMaterial',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/send-message',
    name: 'Send Message',
    view: 'SendMessage',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/change-password',
    name: 'Change Password',
    view: 'ChangePassword',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/delete-message',
    name: 'Delete Message',
    view: 'DeleteMessage',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/daily-quiz-details/:id',
    name: 'Daily Quiz Details',
    view: 'DailyQuizDetails',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lms',
    view: 'LMS',
    name: 'Learning Management',
    meta: {
      lms: true
    }
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/user-list',
    name: 'User List',
    view: 'UserList',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/courses',
    name: 'Courses',
    view: 'Courses',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/course-details/:id',
    name: 'Subject list of course',
    view: 'CourseDetails',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/subjects',
    name: 'Subjects',
    view: 'Subjects',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/subject-details/:courseId/:subjectId',
    name: 'Subject Details',
    view: 'SubjectDetails',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/students',
    name: 'Students',
    view: 'Students',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/chapters',
    name: 'Chapters',
    view: 'Chapters',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/quiz',
    name: 'Quiz',
    view: 'Quiz',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/payment',
    name: 'Search & Payment ',
    view: 'Payment',
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/lecture-sheet',
    name: 'Lecture Sheet',
    view: 'LectureSheet',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/quiz-details',
    name: 'Quiz Details',
    view: 'QuizDetail',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/chapter-details/:courseId/:subjectId/:id',
    name: 'Chapter Information',
    view: 'ChapterDetails',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/lectures',
    name: 'Lectures',
    view: 'Lecture',
    meta: {
      requiresAuth: true,
      isSuperAdmin: true
    }
  },
  {
    path: '/lecture-details/:id',
    name: 'Lecture Details',
    view: 'LectureDetails',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/typography',
    view: 'Typography'
  },
  {
    path: '/icons',
    view: 'Icons'
  },
  {
    path: '/maps',
    view: 'Maps'
  },
  {
    path: '/notifications',
    view: 'Notifications'
  },
  {
    path: '/upgrade',
    name: 'Upgrade to PRO',
    view: 'Upgrade'
  }
]
